import { createContext, type FC, type ReactElement, useState } from 'react';
import type { ArticleWithSubArticlesModel } from '../models';

interface IHelpArticlesContext {
  articlesUpdate: boolean;
  toggleArticlesUpdate: () => void;
  articles: ArticleWithSubArticlesModel[];
  setArticles: (val: ArticleWithSubArticlesModel[]) => void;
  orderedArticles: ArticleWithSubArticlesModel[];
  setOrderedArticles: (val: ArticleWithSubArticlesModel[]) => void;
  positionsDirty: boolean;
  setPositionsDirty: (val: boolean) => void;
  loading: boolean;
  setLoading: (val: boolean) => void;
}

export const HelpArticlesContext = createContext<IHelpArticlesContext>({} as IHelpArticlesContext);

export const HelpArticlesProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const [articlesUpdate, setArticlesUpdate] = useState(false);
  const toggleUpdate = (): void => setArticlesUpdate(!articlesUpdate);

  const [articles, setArticles] = useState<ArticleWithSubArticlesModel[]>([]);
  const [orderedArticles, setOrderedArticles] = useState<ArticleWithSubArticlesModel[]>([]);
  const [positionsDirty, setPositionsDirty] = useState(false);
  const [loading, setLoading] = useState(false);

  return (
    <HelpArticlesContext.Provider
      value={{
        articlesUpdate,
        toggleArticlesUpdate: toggleUpdate,
        articles,
        setArticles,
        orderedArticles,
        setOrderedArticles,
        positionsDirty,
        setPositionsDirty,
        loading,
        setLoading
      }}
    >
      {children}
    </HelpArticlesContext.Provider>
  );
};
